module.exports = __webpack_public_path__ + "img/QRcode.94050c8b.png";